export default __webpack_public_path__ + "static/media/01.c471de0e.jpg";